export function getFileType (value) {
  if (!value) {
    return 'unknown';
  }
  let ext = value?.substr(value?.lastIndexOf('.') + 1);
  let fileType = ''

  switch (ext) {
    case 'jpg':
    case 'jpeg':
    case 'png':
      fileType = 'image'
      break;
    case 'pdf':
      fileType = 'pdf'
      break;
    default:
      fileType = 'docs'
      break;
  }

  return fileType
}

export function getExtType (value) {
  let ext = value?.substr(value?.lastIndexOf('.') + 1);
  return ext
}